import { useContext } from "react";
import { ActivePropertyContext } from "../lib/active-property-context";

export const useActiveProperty = () => {
  const activePropertyContext = useContext(ActivePropertyContext);

  type ActivePropertyContextType = NonNullable<
    typeof activePropertyContext
  >;

  if (activePropertyContext === undefined) {
    return {
      activeProperty: null,
      setActiveProperty: () => Promise.resolve(),
      refetchActiveProperty: () => Promise.resolve(),
      loaded: true,
    } satisfies ActivePropertyContextType;
  }

  return activePropertyContext;
}; 